import api, { request } from '../../../api';
import { groupBy } from '../../../contrib/utils';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';
import { IAdminRoundResultsStore } from './store';

export interface IAdminRoundResultsActions {
  get: (
    roundId: number,
    formatId: number,
    eventId: number,
    force?: boolean
  ) => { adminRoundResults?: IAdminRoundResultsStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  get: async (state: IStore, roundId: number, eventId: number, force?: boolean) => {
    if (state.adminRoundResults[roundId] && !force) {
      return {
        adminRoundResults: state.adminRoundResults
      };
    }

    const response =
      roundId > 0
        ? await request.get(api.results('staff', 'rounds', { round_id: roundId }))
        : await request.get(api.results('staff', 'events', { event_id: eventId }));

    if (response.error) {
      return {
        errors: { adminRoundResults: { msg: 'Error retrieving the Round Format Awards List.' } }
      };
    }

    return {
      adminRoundResults: {
        ...state.adminRoundResults,
        [roundId]: {
          ...state.adminRoundResults[roundId],
          ...groupBy(response, 'flightId')
        }
      }
    };
  }
};

export default actions;
